import { toPartialMatchRegex } from '../../../cdk/utils';
import type { InputAdapter } from './input.adapter';
import { isEditing } from './primitives';

export class IntegerAdapter implements InputAdapter<number> {
  readonly #re = toPartialMatchRegex(/^-?\d{15}$/);

  format(value: number | string | null | undefined): string {
    if (value == null || value === '') {
      return '';
    }
    if (typeof value === 'number') {
      return value.toString();
    }

    return value;
  }
  parse(value: string | undefined | null): number | null {
    if (value == null) {
      return null;
    }
    value = `${value}`;
    const parsedValue = Number.parseInt(value, 10);
    return isNaN(parsedValue) ? null : parsedValue;
  }

  keydownHandler(e: KeyboardEvent) {
    const el = e.target as HTMLInputElement;
    if (isEditing(e)) {
      return;
    }
    const index = el.selectionStart || 0;
    const val = el.value;
    const newVal = val.slice(0, index).concat(e.key, val.slice(index + 1));
    if (!this.#re.test(newVal)) {
      e.preventDefault();
    }
  }
}
